import inviewAnim from "./modules/inview";
import { drawerMenu, smoothScroll } from "./modules/common";
import { accordion } from "./modules/accordion";
import { mvSwiper, nRSwiper } from "./modules/top";
import { recommendSwiper } from "./modules/footer";
import { slider } from "./modules/slider";

import { setModal, globalNav, setAccordion, setHashDetect } from "./modules/libs";
import setContactForm from "./modules/setContactForm";
import PageSearch from "./modules/PageSearch";
import setTopNews from "./modules/setTopNews";
import setTopBlog from "./modules/setTopBlog";
import setProductDetail from "./modules/setProductDetail";
import setApplyBtn from "./modules/setApplyBtn";
import setBanner from "./modules/setBanner";
import setTopSlide from "./modules/setTopSlide";

import zipcodeSearch from "./modules/zipcodeSearch";
import setSearchFormURL from "./modules/setFormURL";


document.addEventListener("DOMContentLoaded", () => {
  setTopSlide();
  setTopNews();
  setTopBlog();
  setProductDetail();
  setApplyBtn();
  setBanner();
  zipcodeSearch();
})

window.addEventListener("load", () => {
  setHashDetect();
  inviewAnim();
  setModal();

  drawerMenu();
  accordion();
  smoothScroll();
  slider.init();
  setContactForm();
  setAccordion();
  setSearchFormURL();


  // mvSwiper();
  // nRSwiper();
  // recommendSwiper();

  // setModal();
  // globalNav();

  new PageSearch({
    target: '.p-faq_faq__accordion__head',
    containerClass: '.p-faq_faq__accordion',
    grandContainerClass: '.p-faq_faq__block',
    trigger: '#js-search-btn',
    marker: true,
    narrow: true,
    count: false,
    control: false,
  });
});
